export const ROUTES = {
  root: '/',
  guideBot: '/guide-the-bot',
  claraConfigure: '/clara/configure',
  about: '/about',
  howToUse: '/how-to-use',
  waysToUseChatGpt: '/ways-to-use/chatgpt',
  waysToUseWebApp: '/ways-to-use/web-app',
  contact: '/contact',
  register: '/register',
  login: '/login',
  verifyEmail: '/verify-email',
  terms: '/terms',
  privacy: '/privacy',
  earlyAccess: '/early-access',
  profile: '/profile',
  confirm: '/confirm',
  feedback: '/feedback',
  propose: '/propose',
  journeyImport: '/journey-import',
  templates: '/templates',
  templatePreview: '/templates/:templateId',
  mainView: '/double-view',
  slider: '/slider',
};

export const LEGACY_ROUTES = {
  mainView: '/DoubleView',
  slider: '/Slider',
};
